
//export const baseUrl = "http://localhost:8383";
export const baseUrl = "https://app.airgate-isp.online";